<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

        <h1>Consulta Processual</h1>

        <div style="text-align: right; width: 100%;" class="mb-5">
            <button type="button" class="btn btn-sm btn-light btn_azul" @click="Consultar()">
                <label class="btn_azul_lbl">Consultar</label>
            </button>

            <button type="button" class="btn btn-sm btn-light btn_branco" @click="Imprimir()" v-if="processos.length > 0">
                <label class="btn_branco_lbl">Im<u>p</u>rimir</label>
            </button>
            
            <button type="button" class="btn btn-sm btn-light btn_branco" @click="Voltar()">
                <label class="btn_branco_lbl"><u>V</u>oltar</label>
            </button>
        </div>

        <div class="form-container mb-3">
            <div class="row mt-3">
                <div class="col-3">
                    <label for="tipo_pesquisa"><strong>Tipo de Pesquisa:</strong></label>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="material-icons-outlined" style="color: orange;">edit</span>
                </div>
                <div class="col-3">
                    <select id="tipo_pesquisa" class="form-control custom-select-sm custom-dropdown" v-model="tipo_pesquisa">
                        <option value="numero_processo">Número de Processo</option>
                        <option value="nome_parte">Nome da Parte</option>
                        <option value="cpf_cnpj">CPF/CNPJ</option>
                        <option value="oab">OAB</option>
                        <option value="originario">Originário / Relacionado</option>
                        <option value="numero_cda">Número CDA / Proc. Adm CDA</option>
                        <option value="ipl">IPL</option>
                    </select>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-3">
                    <strong>{{ labelPesquisa }}:</strong>&nbsp;&nbsp;&nbsp;&nbsp;
                    <a @click="AtivarConsultaSimplificada();" style="cursor: pointer;" ><span class="material-icons" style="color: blue;" title="Consulta simplificada por número de processo">help</span></a>
                </div>
                <div class="col-3">
                    <input type="text" v-model="campo_pesquisa" class="form-control" />
                </div>
            </div>
            
            <div class="row mt-3" v-if="!consulta_simplificada">
                <div class="col-3">
                    <label for="nome_parte"><strong>Nome da Parte*:</strong></label>&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="col-3">
                    <input type="text" v-model="nome_parte" class="form-control" />
                    <span style="font-size: small; color: darkgray;">* Pessoas com muitos processos não podem ser consultadas.</span>
                </div>
            </div>

            <div class="row mt-3" v-if="!consulta_simplificada">
                <div class="col-3">
                    <strong>Número do CPF/CNPJ*:</strong>&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="col-3">
                    <input type="text" v-model="numero_cpf_cnpj" class="form-control" />
                    <span style="font-size: small; color: darkgray;">* Pessoas com muitos processos não podem ser consultadas.</span>
                </div>
            </div>

            <div class="row mt-3" v-if="!consulta_simplificada">
                <div class="col-3">
                    <label for="numero_oab"><strong>Número da OAB:</strong></label>&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="col-3">
                    <input type="text" v-model="numero_oab" class="form-control" />
                    <span style="font-size: small; color: darkgray;">* OABs com muitos processos não podem ser consultados. O resultado da consulta será limitado a 5000 processos.</span>
                </div>
            </div>

            <div class="row mt-3" v-if="!consulta_simplificada">
                <div class="col-3">
                    <label for="originario_relacionado"><strong>Originário/Relacionado:</strong></label>&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="col-3">
                    <input id="originario_relacionado" type="text" v-model="originario_relacionado" class="form-control" />
                </div>
            </div>

            <div class="row mt-3" v-if="!consulta_simplificada">
                <div class="col-3">
                    <label for="num_cda"><strong>Núm. da CDA:</strong></label>&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="col-3">
                    <input type="text" v-model="numero_cda" class="form-control" />
                </div>
            </div>

            <div class="row mt-3" v-if="!consulta_simplificada">
                <div class="col-3">
                    <label for="num_ipl"><strong>Núm. do IPL:</strong></label>&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="col-3">
                    <input type="text" v-model="numero_ipl" class="form-control" />
                </div>
            </div>

            <div class="row mt-3" v-if="!consulta_simplificada">
                <div class="col-3">
                    <label for="classe_processual"><strong>Classe processual:</strong></label>&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="col-3">
                    <select class="form-control custom-select-sm custom-dropdown" v-model="classe_processual_selecionada">
                        <option :value="''">Todos</option>
                        <option v-for="classe in classes_processuais" :key="classe.id" :value="classe.id">{{ classe.descricao }}</option>
                    </select>
                </div>
            </div>

            <div class="row mt-3" v-if="consulta_simplificada">
                <div class="col-3">
                    <strong>{{ labelPesquisa2 }}:</strong>
                </div>
                <div class="col-3">
                    <input type="text" v-model="chave" class="form-control" />
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-3">
                    <strong>Exibir Baixados:</strong>
                </div>
                <div class="col-3">
                    <input type="checkbox" v-model="exibir_baixados" />
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12" style="text-align: right;">
                    <span style="font-size: small; color: gray;">{{ user.is_admin ? '* Você tem permissão de administrador no simulador. Todos os processos são visíveis para você.' : '* Será visível apenas processos que você é autor, co-autor ou defensor do réu.' }}</span>
                </div>
            </div>
        </div>


        <div style="text-align: right; width: 100%;" class="mb-5">
            <button type="button" class="btn btn-sm btn-light btn_azul" @click="Consultar()">
                <label class="btn_azul_lbl">Consultar</label>
            </button>

            <button type="button" class="btn btn-sm btn-light btn_branco" @click="Imprimir()" v-if="processos.length > 0">
                <label class="btn_branco_lbl">Im<u>p</u>rimir</label>
            </button>
            
            <button type="button" class="btn btn-sm btn-light btn_branco" @click="Voltar()">
                <label class="btn_branco_lbl"><u>V</u>oltar</label>
            </button>
        </div>

        <div style="text-align: right; width: 100%;" v-if="processos.length > 0">
            <span style="color: lightgray; font-size: small;">Lista de Processos ({{ processos.length }} registros)</span>
        </div>

        <table class="table table-striped table-bordered mt-2 border" style="font-size: small;" v-if="processos.length > 0" id="printable-section">
            <thead>
                <tr class="text-center">
                    <th scope="col" style="background-color: lightgrey; display: none;">id</th>
                    <th scope="col" style="background-color: lightgrey;">Nº Processo</th>
                    <th scope="col" style="background-color: lightgrey;">Data de Autuação</th>
                    <th scope="col" style="background-color: lightgrey;">Juízo</th>
                    <th scope="col" style="background-color: lightgrey;">Autor</th>
                    <th scope="col" style="background-color: lightgrey;">Réu</th>
                    <th scope="col" style="background-color: lightgrey;">Classe Judicial</th>
                    <th scope="col" style="background-color: lightgrey;">Último Evento</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="processo in processos">
                    <td style="text-align: left; display: none;">{{ processo.id }}</td>
                    <td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual.cor }"><a :href="`${BASE_URL}processos/movimentacao_processual/${processo.id}`" target="_blank">{{ processo.codigo_processo }}</a></td>
                    <td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual.cor }">{{ formatDate(processo.protocolado_em) }}</td>
                    <td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual.cor }">{{ processo.juizo }}</td> <!-- Assumindo que você tenha essa informação disponível -->
                    <td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual.cor }">
                        <template v-for="(parte, index) in processo.polo_ativo" :key="`pa-${index}`">
                            {{ parte.nome }} {{ parte.pivot.principal ? " (Principal)" : "" }}<br>
                        </template>
                    </td>
                    <td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual.cor }">
                        <template v-for="(parte, index) in processo.polo_passivo" :key="`pp-${index}`">
                            {{ parte.nome }} {{ parte.pivot.principal ? " (Principal)" : "" }}<br>
                        </template>
                    </td>
                    <td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual.cor }">{{ processo.classe_processual.descricao }}</td> <!-- Ajuste conforme o nome correto do campo -->
                    <td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual.cor }">{{ formatDate(processo.updated_at) }}</td> <!-- Assumindo que você tenha essa informação disponível -->
                </tr>
            </tbody>
        </table>


    </div>
</template>
  
<script>
import axios from 'axios';
export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            tipo_pesquisa: 'numero_processo',
            campo_pesquisa: '',
            chave: '',
            exibir_baixados: false,
            processos: [],
            consulta_simplificada: false,

            //Campos novos para a consulta completa ..lucastauil 10/12/2025
            nome_parte: '',
            numero_cpf_cnpj: '',
            numero_oab: '',
            originario_relacionado: '',
            numero_cda: '',
            numero_ipl: '',
            classe_processual_selecionada: '',
            classes_processuais: [], 
        };
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        this.CarregarDados('classes');
    },
    methods: {
        Voltar(){
            window.location.href = this.BASE_URL;
        },
        Imprimir(){
            window.print();
        },

        AtivarConsultaSimplificada(){
            this.consulta_simplificada = !this.consulta_simplificada;
        },
        Consultar(){

            /* if(this.campo_pesquisa == ''){
                alert("Campo de pesquisa não pode ser vazio.");
                return;
            } */


            axios.get(this.BASE_URL + 'processos/consulta_buscar', {
                            params: {
                                    tipo_pesquisa: this.tipo_pesquisa,
                                    campo_pesquisa: this.campo_pesquisa,
                                    chave: this.chave,
                                    exibir_baixados: this.exibir_baixados,

                                    nome_parte: this.nome_parte,
                                    numero_cpf_cnpj: this.numero_cpf_cnpj, 
                                    originario_relacionado: this.originario_relacionado,
                                    numero_oab: this.numero_oab,
                                    numero_cda: this.numero_cda,
                                    numero_ipl: this.numero_ipl,
                                    classe_processual_selecionada: this.classe_processual_selecionada,
                                }
                        })
                        .then(response => {
                           this.processos = response.data.data;
                        })
                        .catch(error => {
                            console.error('Erro ao buscar informações dos processos:', error);
                        });
        },

        CarregarDados(dados_carregar){
            axios.get(this.BASE_URL + 'buscar/dados_iniciais/' + dados_carregar)
                .then(response => {
                    if(dados_carregar == 'cidades'){
                        this.cidades = response.data;
                    }
                    else if(dados_carregar == 'ritos'){
                        this.ritos = response.data;
                    }
                    else if(dados_carregar == 'areas'){
                        this.areas = response.data;
                    }
                    else if(dados_carregar == 'classes'){
                        this.classes_processuais = response.data;
                    }

                })
                .catch(error => {
                    console.error('Erro ao buscar informações da '+dados_carregar+':', error);
                });
          },

        formatDate(dateString) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return new Intl.DateTimeFormat('pt-BR', options).format(new Date(dateString));
        }
    },
    computed: {
        // Computed property para determinar o texto do rótulo
        labelPesquisa() {
            return 'Nº Processo';
            //Restante da função comentada após atualização da tela de consulta. Agora existe a tela simplificada e a tela completa de consulta. ..lucastauil 10/12/2025

            switch (this.tipo_pesquisa) {
                case 'numero_processo':
                    return 'Nº Processo';
                case 'nome_parte':
                    return 'Nome da Parte';
                case 'cpf_cnpj':
                    return 'CPF/CNPJ';
                case 'oab':
                    return 'Número da OAB';
                case 'originario':
                    return 'Originário / Relacionado';
                case 'numero_cda':
                    return 'Número CDA / Proc. Adm CDA';
                case 'ipl':
                    return 'IPL';
                default:
                    return 'Nº Processo, Chave'; // Valor padrão se necessário
            }
        },

        labelPesquisa2() {
            return 'Chave';
            //Restante da função comentada após atualização da tela de consulta. Agora existe a tela simplificada e a tela completa de consulta. ..lucastauil 10/12/2025

            switch (this.tipo_pesquisa) {
                case 'numero_processo':
                    return 'Chave';
                case 'nome_parte':
                    return 'Classe Processual';
                case 'cpf_cnpj':
                    return 'Classe Processual';
                case 'oab':
                    return 'Classe Processual';
                case 'originario':
                    return 'Classe Processual';
                case 'numero_cda':
                    return 'Classe Processual';
                case 'ipl':
                    return 'Classe Processual';
                default:
                    return 'Chave'; // Valor padrão se necessário
            }
        }
    }
};
</script>
  
<style scoped>

h1{
  font-size: 26px;
}

.form-container {
    border: 1px solid gray; /* Borda fina cinza */
    padding: 10px;
    position: relative; /* Posição relativa para o posicionamento do título */
    margin-top: 5px; /* Espaçamento superior para visualização do título */
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 5px;
    background-color: #FFFFFF;
}

.form-title {
    position: absolute; /* Posicionamento absoluto do título */
    top: -15px; /* Posiciona o título acima da borda */
    left: 10px; /* Espaçamento da esquerda para o título */
    background: white; /* Fundo branco para o título */
    padding: 0 1px; /* Espaçamento interno do título */
    font-weight: bold;;
}

.btn_azul{
    margin-right: 3px; 
    width: 90px; 
    cursor: pointer; 
    background-color: #007BFF;
}

.btn_branco{
    margin-right: 2px; 
    width: 90px; 
    cursor: pointer; 
    background-color: white;
}

.btn_azul_lbl{
    color: white; 
    vertical-align: middle; 
    cursor: pointer;
}

.btn_branco_lbl{
    color: #007BFF; 
    vertical-align: middle; 
    cursor: pointer;
}

.custom-dropdown {
  height: 35px; /* Diminui a altura do campo select */
  position: relative;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%22292.4%22%20height%3D%22292.4%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20viewBox%3D%220%200%20292.4%20292.4%22%20enable-background%3D%22new%200%200%20292.4%20292.4%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cg%3E%0A%3Cpath%20d%3D%22M287%2069.201a9.7%209.7%200%200%201%201.7%206.813l-4%204%20c-0.092%200.093-0.203%200.166-0.3%200.26l-127%20127c-1.8%201.801-4.501%202.701-7.1%202.701s-5.3-0.9-7.1-2.7l-127-127c-0.1-0.094-0.2-0.167-0.3-0.26l-4-4c-1.8-1.801-1.8-4.701%200-6.5%200.9-0.899%202.3-1.5%203.6-1.5h254.8c1.3%200%202.7%200.601%203.6%201.5z%22%20fill%3D%22%23000000%22/%3E%0A%3C/g%3E%0A%3C/svg%3E');
  background-position: right 0.75rem center;
  background-size: 10px 10px;
  background-repeat: no-repeat;
}

/* Estilo para manter o ícone de seta mesmo com o select aberto */
.custom-dropdown:focus {
  background-image: none;
  outline: none;
}

/* Estilo para reverter o ícone de seta padrão */
.custom-dropdown::-ms-expand {
  display: none;
}

</style>
  
